var map = {
	"./background-lms": 16,
	"./background-lms.png": 16,
	"./loading": 17,
	"./loading.gif": 17,
	"./video-play": 18,
	"./video-play.png": 18,
	"./vimeo-play": 19,
	"./vimeo-play.png": 19,
	"./youtube-play": 20,
	"./youtube-play.png": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;